import { QuestionCircleOutlined } from '@ant-design/icons'
import { Col, Form, InputNumber, Row, Tooltip } from 'antd'

const Properties = ({ edit }: { edit: boolean }) => {
  const styleInput = {
    color: 'rgba(0, 0, 0, 0.85)',
    width: '100%',
  }

  const PROPERTIES = [
    {
      label: 'Total Investment Value',
      field: 'totalInvestmentValue',
      min: 0,
      type: 'number',
    },
    {
      label: 'Underlying Asset Price',
      field: 'underlyingAssetPrice',
      min: 0,
      type: 'number',
    },
    {
      label: 'Total Closing Costs',
      field: 'totalClosingCosts',
      min: 0,
      type: 'number',
    },
    {
      label: 'MeyFi Closing Fee (3 %)',
      field: 'closingFee',
      min: 0,
      type: 'number',
    },
    {
      label: 'DAO LLC Costs',
      field: 'daoLlcCosts',
      min: 0,
      type: 'number',
    },
    {
      label: 'Property Valuation Fee',
      field: 'propertyValuationFee',
      min: 0,
      type: 'number',
    },
    {
      label: 'Annual Audit',
      field: 'annualAudit',
      min: 0,
      type: 'number',
    },
    {
      label: 'Annual Registration',
      field: 'annualRegistration',
      min: 0,
      type: 'number',
    },
    {
      label: 'Reserve Fund (1st year)',
      field: 'reserveFund',
      min: 0,
      type: 'number',
    },
    {
      label: 'Property Transfer Fee',
      field: 'propertyTransferFee',
      min: 0,
      type: 'number',
    },
    {
      label: 'Total Projected Gross Yield',
      field: 'totalProjectedGrossYield',
      min: 0,
      type: 'percent',
    },
    {
      label: 'Projected Appreciation',
      field: 'projectedAppreciation',
      min: 0,
      type: 'percent',
    },
    {
      label: 'Cash on Cash Return',
      field: 'cashOnCashReturn',
      min: 0,
      type: 'percent',
    },
    {
      label: 'Cap Rate',
      field: 'capRate',
      min: 0,
      type: 'percent',
    },
    {
      label: 'Monthly Gross Rents',
      field: 'monthlyGrossRents',
      min: 0,
      type: 'number',
    },
    {
      label: 'Monthly Hotel Operation Fee',
      field: 'monthlyHotelOperationFee',
      min: 0,
      type: 'number',
    },
    {
      label: 'Total Monthly Costs',
      field: 'totalMonthlyCosts',
      min: 0,
      type: 'number',
    },
    {
      label: 'Expense to Income Ratio',
      field: 'expenseToIncomeRatio',
      min: 0,
      type: 'percent',
    },
    {
      label: 'Monthly Net Cash Flow',
      field: 'monthlyNetCashFlow',
      min: 0,
      type: 'number',
    },
  ]

  return (
    <fieldset>
      <legend>Properties</legend>
      <Row gutter={24}>
        {PROPERTIES.map((property, index) => {
          return (
            <Col span={8} key={index}>
              <Form.Item
                label={
                  <>
                    {property.label}
                    <Tooltip
                      title={
                        <div className="tooltip-box">
                          <p className="tooltip-text">
                            This is your PTO {property.label.toLowerCase()}
                            &nbsp; property, please enter your chosen&nbsp;
                            {property.label.toLowerCase()}&nbsp;as&nbsp;
                            {property.type}
                          </p>
                        </div>
                      }
                      placement="right"
                    >
                      <QuestionCircleOutlined className="tooltip-icon" />
                    </Tooltip>
                  </>
                }
                name={property.field}
              >
                {property.type === 'percent' ? (
                  <InputNumber<number>
                    style={styleInput}
                    addonAfter={'%'}
                    disabled={!edit}
                    min={0}
                    max={100}
                    placeholder={`Enter ${property.label.toLowerCase()}`}
                    defaultValue={0}
                  />
                ) : (
                  <InputNumber<number>
                    style={styleInput}
                    min={0}
                    addonBefore="$"
                    addonAfter={'USDT'}
                    disabled={!edit}
                    defaultValue={0}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, '') as unknown as number}
                    placeholder={`Enter ${property.label.toLowerCase()}`}
                  />
                )}
              </Form.Item>
            </Col>
          )
        })}
      </Row>
    </fieldset>
  )
}

export default Properties
